import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './contact-rms.reducer';

export const ContactRms = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const contactRmsList = useAppSelector(state => state.contactRms.entities);
  const loading = useAppSelector(state => state.contactRms.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="contact-rms-heading" data-cy="ContactRmsHeading">
        <Translate contentKey="crawlerBackendApp.contactRms.home.title">Contact Rms</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.contactRms.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/contact-rms/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.contactRms.home.createLabel">Create new Contact Rms</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {contactRmsList && contactRmsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('firstName')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.firstName">First Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('firstName')} />
                </th>
                <th className="hand" onClick={sort('lastName')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.lastName">Last Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastName')} />
                </th>
                <th className="hand" onClick={sort('company')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.company">Company</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('company')} />
                </th>
                <th className="hand" onClick={sort('kvk')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.kvk">Kvk</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('kvk')} />
                </th>
                <th className="hand" onClick={sort('email')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.email">Email</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('email')} />
                </th>
                <th className="hand" onClick={sort('phoneNumber')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.phoneNumber">Phone Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('phoneNumber')} />
                </th>
                <th className="hand" onClick={sort('message')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.message">Message</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('message')} />
                </th>
                <th className="hand" onClick={sort('fileContactPath')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.fileContactPath">File Contact Path</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fileContactPath')} />
                </th>
                <th className="hand" onClick={sort('consent')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.consent">Consent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consent')} />
                </th>
                <th className="hand" onClick={sort('checkSendEmail')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.checkSendEmail">Check Send Email</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('checkSendEmail')} />
                </th>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="crawlerBackendApp.contactRms.type">Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('type')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {contactRmsList.map((contactRms, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/contact-rms/${contactRms.id}`} color="link" size="sm">
                      {contactRms.id}
                    </Button>
                  </td>
                  <td>{contactRms.firstName}</td>
                  <td>{contactRms.lastName}</td>
                  <td>{contactRms.company}</td>
                  <td>{contactRms.kvk}</td>
                  <td>{contactRms.email}</td>
                  <td>{contactRms.phoneNumber}</td>
                  <td>{contactRms.message}</td>
                  <td>{contactRms.fileContactPath}</td>
                  <td>{contactRms.consent ? 'true' : 'false'}</td>
                  <td>{contactRms.checkSendEmail}</td>
                  <td>{contactRms.type}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/contact-rms/${contactRms.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/contact-rms/${contactRms.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/contact-rms/${contactRms.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.contactRms.home.notFound">No Contact Rms found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ContactRms;
